import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { NavItems } from "./NavItems";
import { Link } from "react-router-dom";

interface MobileNavProps {
  onLogin: () => void;
}

export const MobileNav = ({ onLogin }: MobileNavProps) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="h-10 w-10">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Open menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[300px] sm:w-[350px] p-0">
        <div className="flex flex-col h-full">
          <div className="border-b p-4">
            <div className="flex items-center justify-between mb-4">
              <img 
                src="/lovable-uploads/d8edf8a7-daeb-4805-8270-304464f41613.png" 
                alt="MindTube" 
                className="h-8"
              />
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="h-8 w-8">
                  <X className="h-4 w-4" />
                  <span className="sr-only">Close menu</span>
                </Button>
              </SheetTrigger>
            </div>
          </div>

          <nav className="flex flex-col py-4 border-b">
            <NavItems />
          </nav>

          <div className="mt-auto p-4 border-t">
            <Button 
              variant="ghost" 
              onClick={onLogin} 
              className="w-full justify-center min-h-[44px] mb-3"
            >
              Login
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};